/**
 * Constantes del feature "rangos"
 */

// Valor mostrado/comparado en la columna Transportista cuando el rango no
// tiene id_agencia asignado (vacío/null). Replica el fallback del legado
// (src/views/Rangos.js, valueGetter: `params.value || '000'`). No hay
// confirmación de backend de qué representa '000' (ver docs/api/rangos.md,
// sección "Puntos sin verificar" #6: podría ser una agencia "genérica", un
// mostrador, o un simple placeholder de UI sin contrapartida real); se
// conserva el mismo valor por defecto para no cambiar el comportamiento
// funcional observado al migrar.
//
// Centralizada aquí (TASK-007) porque estaba duplicada como constante local
// en helpers/columns.js y components/lists/RangosMobileList.js.
export const SIN_TRANSPORTISTA_ASIGNADO = "000";
